import { MicroService } from './Clients/MicroService';
import { ICourseData } from 'types/ICourseData';

export const MicroServiceRepository = {
  getCourseData(courseId: string): Promise<ICourseData> {
    return MicroService.get(`/${courseId}`).then((res) => res.data);
  },
};
